import { useState, useEffect } from 'react';

export default function Testimonials() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      quote: "Revulist's free, easy, simple. It works—literally the best solution for your healthcare practice.",
      author: "Dr. Sarah Chen, Family Medicine",
      location: "San Francisco, CA"
    },
    {
      quote: "Revulist has been invaluable to us, not only for patient referrals but also for validation and credibility.",
      author: "Metro Health Clinic",
      location: "Austin, TX"
    },
    {
      quote: "Revulist is unique in that it provides me with patients who are loyal and drive strong long-term relationships.",
      author: "Dr. Michael Rodriguez, Cardiology",
      location: "Miami, FL"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  return (
    <section className="py-16 bg-teal-900 text-white">
      <div className="max-w-4xl mx-auto px-4 text-center">
         <h2 className="text-3xl font-bold mb-8">What they say</h2>
         <div className="min-h-[200px] flex flex-col justify-center items-center transition-opacity duration-500">
            <p className="text-xl italic mb-4">"{testimonials[currentTestimonial].quote}"</p>
            <div className="font-bold">{testimonials[currentTestimonial].author}</div>
            <div className="text-teal-200 text-sm">{testimonials[currentTestimonial].location}</div>
         </div>
         
         {/* Dots indicator */}
         <div className="flex justify-center gap-2 mt-6">
            {testimonials.map((_, idx) => (
              <button 
                key={idx}
                onClick={() => setCurrentTestimonial(idx)}
                className={`w-3 h-3 rounded-full ${idx === currentTestimonial ? 'bg-white' : 'bg-teal-700'}`}
              />
            ))}
         </div>
      </div>
    </section>
  );
}